<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        v-if="visible"
        class="dialog-overlay"
        @click="handleOverlayClick"
      ></div>
    </transition>

    <!-- 弹窗 -->
    <transition name="pop">
      <div v-if="visible" class="dialog-container">
        <div class="dialog-content" @click.stop>
          <!-- 关闭按钮 -->
          <button class="close-btn" @click="close">×</button>

          <div class="dialog-body">
            <!-- 左边：图片展示部分 -->
            <div class="image-section">
              <!-- 主图 -->
              <div class="main-image">
                <img :src="mainImage" alt="" />
              </div>

              <!-- 图片轮播 -->
              <div class="image-carousel">
                <swiper
                  ref="goodsSwiper"
                  class="goods-swiper"
                  :options="swiperOptions"
                >
                  <swiper-slide
                    v-for="(img, index) in imageList"
                    :key="index"
                    :class="{ selected: selectedImageIndex === index }"
                  >
                    <div
                      class="carousel-item"
                      :class="{ active: selectedImageIndex === index }"
                      @click="selectImage(img, index)"
                    >
                      <img :src="img" alt="" />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>

            <!-- 右边：信息展示部分 -->
            <div class="info-section">
              <!-- 商品名称 -->
              <div class="goods-name">{{ goodsData.name }}</div>

              <!-- 商品描述 -->
              <div class="goods-desc" v-html="goodsData.content"></div>

              <!-- 兑换积分 -->
              <div class="goods-exchange">
                <div class="exchange-left">
                  <div class="exchange-label">
                    {{ $t("goodsDialog.goods1") }}
                  </div>
                  <div class="exchange-value">
                    <strong>{{ goodsData.point }}</strong>
                    <span v-if="Number(goodsData.amount)">
                      + {{ goodsData.amount }}VND</span
                    >
                  </div>
                </div>
                <div class="exchange-right">
                  <div class="remaining-label">
                    {{ $t("goodsDialog.goods2") }}
                  </div>
                  <div class="remaining-value">
                    {{ Math.max(0, goodsData.total - goodsData.used) }}/{{
                      goodsData.total
                    }}
                  </div>
                </div>
              </div>

              <!-- 购买按钮 -->
              <div class="action-buttons">
                <el-button
                  type="primary"
                  size="medium"
                  @click="handleExchange"
                  class="exchange-btn"
                  :disabled="goodsData.show ? false : true"
                >
                  {{ goodsData.btn }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <ExchangeDialog
      ref="exchangeDialog"
      @exchange-success="handleExchangeSuccess"
    />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ExchangeDialog from "./exchangeDialog.vue";

export default {
  name: "GoodsDialog",
  components: {
    ExchangeDialog,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      visible: false,
      goodsData: {
        id: "",
        name: "",
        content: "",
        point: "",
        amount: "",
        img: "",
      },
      mainImage: "",
      imageList: [],
      selectedImageIndex: 0,
      swiperOptions: {
        direction: "horizontal",
        loop: false,
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 10,
        autoplay: false,
      },
    };
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} data 商品数据
     */
    open(data) {
      if (data) {
        this.goodsData = { ...data };
        this.mainImage = JSON.parse(data.image)[0];
        // 默认用商品图片补齐五张
        // this.imageList = [data.img, data.img, data.img, data.img, data.img];
        this.imageList = JSON.parse(data.image);
        this.selectedImageIndex = 0;
      }
      this.visible = true;
    },

    /**
     * 关闭弹窗
     */
    close() {
      this.visible = false;
    },

    /**
     * 选择图片
     */
    selectImage(img, index) {
      this.mainImage = img;
      this.selectedImageIndex = index;
    },

    /**
     * 处理兑换
     */
    handleExchange() {
      if (!this.goodsData.show) {
        return;
      }
      this.$refs.exchangeDialog.open(this.goodsData);
    },

    /**
     * 兑换成功回调
     */
    handleExchangeSuccess() {
      this.close();
      this.$emit("exchange-success", this.goodsData);
    },

    /**
     * 处理遮罩层点击
     */
    handleOverlayClick() {
      // 如果需要点击遮罩层关闭弹窗，取消注释下一行
      // this.close();
    },
  },
};
</script>

<style scoped lang="scss">
// 遮罩层
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

// 弹窗容器
.dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

// 弹窗内容
.dialog-content {
  background: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 90vw;
  max-width: 1000px;
  height: auto;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

// 关闭按钮
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  font-size: 24px;
  color: #333;
  border-radius: 4px;

  &:hover {
    background: rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
  }
}

// 弹窗主体
.dialog-body {
  display: flex;
  gap: 30px;
  margin-top: 30px;
  align-items: stretch;
  height: 100%;
}

// 图片展示区域
.image-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 0;
}

// 主图
.main-image {
  width: 100%;
  height: 300px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

// 图片轮播
.image-carousel {
  width: 100%;

  .goods-swiper {
    padding: 10px 10px;
  }

  .carousel-item {
    width: 100%;
    height: 80px;
    background: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    border: 2px solid transparent;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &:hover,
    &.active {
      border-color: #409eff;
      transform: scale(1.05);
    }
  }
}

// 右边：信息展示部分
.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  justify-content: space-between;
}

// 商品名称
.goods-name {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}

// 商品描述
.goods-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  max-height: 120px;
  overflow-y: auto;
  flex: 0 1 auto;

  :deep(p) {
    margin: 0 0 10px 0;
  }

  :deep(div) {
    margin: 0 0 10px 0;
  }
}

// 兑换积分
.goods-exchange {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  gap: 20px;

  .exchange-left,
  .exchange-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .exchange-label,
  .remaining-label {
    font-size: 14px;
    color: #999;
    white-space: nowrap;
  }

  .exchange-value {
    font-size: 16px;
    color: #ff6b6b;

    strong {
      font-size: 20px;
    }

    span {
      margin-left: 10px;
      font-size: 12px;
    }
  }

  .remaining-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

// 操作按钮
.action-buttons {
  display: flex;
  gap: 10px;

  .exchange-btn {
    width: 100%;
  }
}

// 弹出动画
.pop-enter-active {
  animation: popIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pop-leave-active {
  animation: popOut 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
  from {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes popOut {
  from {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 响应式设计
@media (max-width: 1024px) {
  .dialog-content {
    width: 95vw;
    padding: 15px;
  }

  .dialog-body {
    flex-direction: column;
    gap: 20px;
  }

  .main-image {
    height: 250px;
  }

  .info-section {
    padding: 15px;
  }

  .goods-name {
    font-size: 16px;
  }
}

// 小手机适配
@media (max-width: 768px) {
  .dialog-content {
    width: 95vw;
    max-width: none;
    padding: 12px;
    margin: 0 auto;
  }

  .close-btn {
    width: 28px;
    height: 28px;
    font-size: 20px;
    top: 8px;
    right: 8px;
  }

  .dialog-body {
    flex-direction: column;
    gap: 15px;
    margin-top: 7vw;
  }

  .image-section {
    gap: 10px;
  }

  .main-image {
    height: 200px;
  }

  .image-carousel {
    .goods-swiper {
      padding: 8px;
    }

    .carousel-item {
      height: 70px;
    }
  }

  .info-section {
    padding: 12px;
    gap: 15px;
  }

  .goods-name {
    font-size: 14px;
    line-height: 1.3;
  }

  .goods-desc {
    font-size: 12px;
    max-height: 100px;
    line-height: 1.5;
  }

  .goods-exchange {
    padding-bottom: 12px;
    gap: 15px;

    .exchange-label,
    .remaining-label {
      font-size: 12px;
    }

    .exchange-value {
      font-size: 14px;

      strong {
        font-size: 16px;
      }

      span {
        font-size: 11px;
        margin-left: 5px;
      }
    }

    .remaining-value {
      font-size: 12px;
    }
  }

  .action-buttons {
    :deep(.el-button) {
      padding: 8px 16px;
      font-size: 13px;
      height: 36px;
    }
  }
}

// 超小手机适配（小于 480px）
@media (max-width: 480px) {
  .dialog-content {
    width: 95vw;
    max-width: none;
    padding: 10px;
    border-radius: 8px;
  }

  .close-btn {
    width: 24px;
    height: 24px;
    font-size: 18px;
    top: 6px;
    right: 6px;
  }

  .dialog-body {
    gap: 12px;
  }

  .image-section {
    gap: 8px;
  }

  .main-image {
    height: 150px;
  }

  .image-carousel {
    .goods-swiper {
      padding: 6px;
    }

    .carousel-item {
      height: 60px;
    }
  }

  .info-section {
    padding: 10px;
    gap: 12px;
  }

  .goods-name {
    font-size: 13px;
  }

  .goods-desc {
    font-size: 11px;
    max-height: 80px;
  }

  .goods-exchange {
    padding-bottom: 10px;
    gap: 12px;

    .exchange-label,
    .remaining-label {
      font-size: 11px;
    }

    .exchange-value {
      font-size: 12px;

      strong {
        font-size: 14px;
      }

      span {
        font-size: 10px;
        margin-left: 4px;
      }
    }

    .remaining-value {
      font-size: 11px;
    }
  }

  .action-buttons {
    :deep(.el-button) {
      padding: 6px 12px;
      font-size: 12px;
      height: 32px;
    }
  }
}
</style>
